import React from 'react';

import { Dialog } from '@shared/components';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';

import DoneIcon from '@assets/icons/done-green.svg';

import useStyles from './style';

const noop = () => {};

const UploadDialog = ({
  isOpen = false,
  onChange = noop,
  onClose = noop,
  handleUpload = noop,
  selectedFile = null,
}) => {
  const classes = useStyles();
  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      open={isOpen}
      onClose={onClose}
      classes={{
        paper: classes.uploadDialog,
      }}
    >
      <Dialog.Title hasClose></Dialog.Title>
      <Dialog.Content>
        <div>
          <Typography variant='h6'>Upload File</Typography>
          <Typography variant='body2' className='color-text-secondary mb-5'>
            Please select the file to upload.
          </Typography>
          <div className='d-flex f-align-center'>
            <div>
              <input
                id='extension-file'
                type='file'
                className='d-none'
                accept={`.xls, .xlsx`}
                onChange={onChange}
                onClick={evt => (evt.currentTarget.value = '')}
              />
              <Button
                variant='contained'
                component='label'
                color='primary'
                htmlFor='extension-file'
              >
                Choose File
              </Button>
            </div>
          </div>
          {selectedFile && (
            <div className='d-flex f-align-center w-75 mt-4 mb-4'>
              <Tooltip title={selectedFile.name} placement='top-start'>
                <Typography
                  variant='body2'
                  className='color-text-secondary mr-4'
                  noWrap
                >
                  {selectedFile.name}
                </Typography>
              </Tooltip>
              <img src={DoneIcon} alt='done-icon' width={24} />
            </div>
          )}
        </div>
      </Dialog.Content>
      <Dialog.Actions>
        <div>
          <Button variant='outlined' className='mr-4 mb-4' onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant='contained'
            color='primary'
            className='mr-4 mb-4'
            onClick={handleUpload}
            disabled={!selectedFile}
          >
            Next
          </Button>
        </div>
      </Dialog.Actions>
    </Dialog>
  );
};
export default UploadDialog;
